import { render, staticRenderFns } from "./TagsFilter.vue?vue&type=template&id=233a3f05&scoped=true&lang=pug"
import script from "./TagsFilter.vue?vue&type=script&lang=js"
export * from "./TagsFilter.vue?vue&type=script&lang=js"
import style0 from "./TagsFilter.vue?vue&type=style&index=0&id=233a3f05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233a3f05",
  null
  
)

export default component.exports